import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

function ListProperty() {
  return (
    <div>
      {/* Propertie Section Start */}
      <section className="propertie-section fix section-padding section-bg">
        <div className="container">
          <div className="section-title-area">
            <div className="section-title">
              <h5 className="wow fadeInUp">
                <i className="flaticon-home"></i> OUR Gallery{" "}
                <i className="flaticon-home"></i>
              </h5>
              <h2 className="wow fadeInUp" data-wow-delay=".3s">
                Memories from Shree JRB Events
              </h2>
            </div>
          </div>
        </div>

        <div className="propertie-wrapper">
          {/* First Slider */}
          <Swiper
            modules={[Navigation]}
            navigation={true}
            spaceBetween={20}
            slidesPerView={2}
            loop={true}
            className="propertie-slider1"
          >
            <SwiperSlide>
              <div className="propertie-box-image">
                <img src="/img/1.jpeg" alt="img" />
                <img src="/img/11.jpeg" alt="img" />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="propertie-box-image">
                <img src="/img/2.jpeg" alt="img" />
                <img src="/img/12.jpeg" alt="img" />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="propertie-box-image">
                <img src="/img/3.jpeg" alt="img" />
                <img src="/img/13.jpeg" alt="img" />
              </div>
            </SwiperSlide>
          </Swiper>

          {/* Second Slider */}
          <Swiper
            modules={[Navigation]}
            navigation={true}
            spaceBetween={20}
            slidesPerView={2}
            loop={true}
            className="propertie-slider2"
          >
            <SwiperSlide>
              <div className="propertie-box-image">
                <img src="/img/4.jpeg" alt="img" />
                <img src="/img/14.jpeg" alt="img" />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="propertie-box-image">
                <img src="/img/5.jpeg" alt="img" />
                <img src="/img/15.jpeg" alt="img" />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="propertie-box-image">
                <img src="/img/6.jpeg" alt="img" />
                <img src="/img/16.jpeg" alt="img" />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="propertie-box-image">
                <img src="/img/7.jpeg" alt="img" />
                <img src="/img/8.jpeg" alt="img" />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="propertie-box-image">
                <img src="/img/9.jpeg" alt="img" />
                <img src="/img/10.jpeg" alt="img" />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
    </div>
  );
}

export default ListProperty;
